import { AnalyticsContextValue } from "@swiggy-private/checkout-core";
import { SCREEN_NAME, CLICK_ACTIONS, IMPRESSION_ACTIONS } from "../constants";
import { getCouponType } from "../helper";
import { CouponsAnalyticsExtraContext, CouponsAnalyticsExtraParams } from "@cart-client/interfaces/Coupon";
import { GiftingCouponCode } from "@swiggy-private/cart-types";

export const clickApplyCouponBtnEvent = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    {
        couponCode = "",
        groupCartId,
        isPaymentCouponWidget,
        extraParams,
        extraContext,
    }: {
        couponCode?: string;
        groupCartId?: string;
        isPaymentCouponWidget?: boolean;
        extraParams?: CouponsAnalyticsExtraParams;
        extraContext?: CouponsAnalyticsExtraContext;
    },
): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        label: JSON.stringify({
            couponCode,
            couponType: getCouponType(isPaymentCouponWidget),
        }),
        action: CLICK_ACTIONS.CLICK_APPLY_COUPON_BUTTON,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        extraParams: JSON.stringify({ grp_cart_id: groupCartId, ...(extraParams ?? {}) }),
        context: JSON.stringify({ ...(extraContext ?? {}) }),
    });
};

export const clickViewMoreCouponsEvent = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    {
        groupCartId,
        extraParams = {},
        extraContext = {},
    }: {
        groupCartId?: string;
        extraParams?: CouponsAnalyticsExtraParams;
        extraContext?: CouponsAnalyticsExtraContext;
    },
): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_VIEW_MORE_COUPONS,
        context: JSON.stringify({ ...extraContext }),
        // eslint-disable-next-line @typescript-eslint/naming-convention
        extraParams: JSON.stringify({ grp_cart_id: groupCartId, ...(extraParams ?? {}) }),
    });
};

export const clickTooltipOffercashEvent = (
    couponName: string,
    clickEvent: AnalyticsContextValue["clickEvent"],
): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        value: couponName,
        action: CLICK_ACTIONS.CLICK_TOOLTIP_OFFERCASH,
    });
};

export const impressionDirectCouponWidgetEvent = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    couponCode: string,
    groupCartId?: string,
    isPaymentCouponWidget?: boolean,
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        label: JSON.stringify({
            couponCode,
            couponType: getCouponType(isPaymentCouponWidget),
        }),
        action: IMPRESSION_ACTIONS.IMPRESSION_DIRECT_COUPON_WIDGET,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        extraParams: JSON.stringify({ grp_cart_id: groupCartId }),
    });
};

export const impressionCouponCodeForGifting = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    couponCode: GiftingCouponCode,
    applied?: boolean,
    giftingAnalyticsExtraParams?: CouponsAnalyticsExtraParams,
): void => {
    impressionEvent({
        category: SCREEN_NAME.GIFTING_CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_GIFTING_APPLIED_COUPON,
        context: JSON.stringify({ couponCode, applied }),
        extraParams: JSON.stringify(giftingAnalyticsExtraParams),
    });
};
